import React, { forwardRef } from 'react'
import { useSelector } from 'react-redux'
import { Link, type LinkProps } from '@mui/material'
import { Defaults } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getCurrentBusiness } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'

export interface LeftMenuSupportButtonProps extends LinkProps {}

const LeftMenuSupportButton = forwardRef<
  HTMLAnchorElement,
  LeftMenuSupportButtonProps
>(function LeftMenuSupportButton(props, ref) {
  const isRenameQuestionsAndChatEnabled = useSelector(
    getFeatureToggle(FeatureToggle.CVC_13939_UPDATE_RHAPSODY_NAV),
  )
  const currentBusiness = useSelector(getCurrentBusiness)

  let supportUrl = Defaults.THIRD_PARTY_SUPPORT_URL
  if (isRenameQuestionsAndChatEnabled && currentBusiness?.omniChannel) {
    supportUrl = Defaults.CVC_SUPPORT_URL
  }

  return (
    <Link
      href={supportUrl}
      ref={ref}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    />
  )
})

export default LeftMenuSupportButton
